import { PropertyFilterProcessingNode } from './PropertyFilterProcessingNode';
/**
 * @category Processing node
 */
export class LPFilterNode extends PropertyFilterProcessingNode {
  constructor(propertySelector, propertyModifier, options) {
    super(propertySelector, propertyModifier, options);
  }
  initFilter(object, value, options) {
    return new Promise(resolve => {
      let alpha = options.alpha;
      if (alpha === undefined) {
        const rc = 1.0 / (options.cutOff * 2 * Math.PI);
        const dt = 1.0 / options.sampleRate;
        alpha = dt / (rc + dt);
      }
      resolve({
        x: value,
        alpha
      });
    });
  }
  filter(object, value, filter) {
    return new Promise(resolve => {
      if (typeof value === 'number') {
        filter.x = filter.x + filter.alpha * (value - filter.x);
      } else {
        const vector = value.clone();
        const filterVector = filter.x;
        filter.x = filterVector.add(vector.sub(filter.x).multiplyScalar(filter.alpha));
      }
      resolve(filter.x);
    });
  }
}